// extracted by mini-css-extract-plugin
module.exports = {"allAvailableBlocks":"allAvailableBlocks__7+4G2"};